import PropTypes from 'prop-types';
import {
    LoaderMi,
    Fieldset,
    BoutonRadio,
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    Bouton,
    GroupeBouton,
} from '@design-system-etat/dsfr-react';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const ModalBan = ({ residence, isLoading, data, fermerModal, remplacer, conserver }) => {
    const { register, watch, setValue } = useForm({
        mode: 'onChange',
    });

    useEffect(() => {
        setValue('choixBan', 'conserver');
    });

    const typeResidence = () => {
        if (residence === 'principale') {
            return 'résidence principale';
        }
        if (residence === 'secondaire') {
            return 'résidence secondaire';
        }
        return null;
    };

    const continuer = () => {
        if (watch('choixBan') === 'remplacer') {
            remplacer();
        } else {
            conserver();
        }
    };

    return (
        <>
            {isLoading && <LoaderMi taille="lg" />}
            {!isLoading && (
                <Modale id="notification" closeCallback={fermerModal} taille="lg">
                    <ModaleTitre idModale="notification">Notification</ModaleTitre>
                    {data ? (
                        <ModaleContent>
                            <p className="text-center">
                                L&apos;adresse renseignée pour la {typeResidence()} correspond au
                                résultat suivant dans la base nationale des adresses :
                            </p>
                            <p className="text-center">
                                <b>
                                    {data.numeroVoie} {data.libelleVoie}
                                    <br />
                                    {data.codePostal} {data.ville}
                                </b>
                            </p>
                            <p className="text-center">
                                Souhaitez-vous conserver votre adresse ou la remplacer par celle
                                ci-dessus ?
                            </p>
                            <div className="choix-actions-adresse">
                                <Fieldset id="choixBanForm" alignementHorizontal>
                                    <BoutonRadio
                                        type="radio"
                                        name="choixBan"
                                        label="Conserver"
                                        value="conserver"
                                        taille="sm"
                                        {...register('choixBan')}
                                    />
                                    <BoutonRadio
                                        type="radio"
                                        name="choixBan"
                                        label="Remplacer"
                                        value="remplacer"
                                        taille="sm"
                                        {...register('choixBan')}
                                    />
                                </Fieldset>
                            </div>
                        </ModaleContent>
                    ) : (
                        <ModaleContent>
                            <p>
                                Votre adresse n&apos;a pas été trouvée dans la base nationale des
                                adresses.
                            </p>
                            <p>
                                Cliquez sur &quot;continuer&quot; pour conserver votre adresse ou
                                sur &quot;retour&quot; afin de la modifier
                            </p>
                        </ModaleContent>
                    )}
                    <ModaleFooter>
                        <GroupeBouton isHorizontal alignementHorizontal="right">
                            <Bouton
                                name="Annuler"
                                label="Annuler"
                                niveau="secondaire"
                                onClick={fermerModal}
                            />
                            <Bouton
                                name="Continuer"
                                label="Continuer"
                                niveau="primaire"
                                onClick={continuer}
                            />
                        </GroupeBouton>
                    </ModaleFooter>
                </Modale>
            )}
        </>
    );
};

ModalBan.propTypes = {
    residence: PropTypes.string.isRequired,
    fermerModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    data: PropTypes.any,
    remplacer: PropTypes.func.isRequired,
    conserver: PropTypes.func.isRequired,
};

export default ModalBan;
